import React, {useState, useEffect} from "react";
import axios from 'axios';
import "./../../../css/Forms.css";
import "./../../../css/SARs.css";
import { statusIsGood } from "../../../helpers/http";
import TermSelector from "../../HelperComponents/SARs/TermSelector";
import EvaluationOfAdvisor from "../../HelperComponents/SARs/EvaluationOfAdvisor";
import TermSelector2 from "../../HelperComponents/SARs/TermSelector2";
import Tooltip from '@mui/material/Tooltip';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function SAR_Form({ CurrentUser }) {
    const [isLoaded, setIsLoaded] = useState(false);
    const [sar, setSar] = useState({});
    const [allFaculty, setAllFaculty] = useState([]);
    const [currentYear, setCurrentYear] = useState(2026);
    const [degreeType, setDegreeType] = useState("PhD");
    const [admissionTerm, setAdmissionTerm] = useState(0);
    const [facultyAdvisors, setFacultyAdvisors] = useState([]); //Array rather than dictionary b/c a student can have the same advisor multiple times?
    const [milestones, setMilestones] = useState({});
    const [fundingTerms, setFundingTerms] = useState({});
    const [publications, setPublications] = useState([]);
    const [publicationYears, setPublicationYears] = useState([]);
    const [deptEval, setDeptEval] = useState({});
    const [evalOfAdvisors, setEvalOfAdvisors] = useState([]);
    const [newEoA, setNewEoA] = useState(-1);
    const [hasCurrentFA, setHasCurrentFA] = useState(false);
    const [errors, setErrors] = useState({});
    const [eoaErrors, setEoAErrors] = useState([]);
    const [validating, setValidating] = useState(false);

    useEffect(() => { //Saving w/ debounce
        if(isLoaded) { //Try not to run on initial load
            if(validating) validateForm2();
            else lengthCheck();
    //        const handler = setTimeout(() => console.log({...sar}), 5000);
    //        return () => clearTimeout(handler);
        }
    }, [sar, degreeType, admissionTerm, facultyAdvisors, milestones, fundingTerms, publications, deptEval, evalOfAdvisors, hasCurrentFA]);

    useEffect(()=>{
        if(validating)
            validateForm2();
        else
            setErrors({});
    }, [validating]);

    const emptySAR = {
        studentName: "",
        studentPID: "",
        acceleratedMasters: "",
        enrollment: false,
        ethics_rcr: false,
        ethics_coi: false,
        presentations: "",
        internships: "",
        activities: "",
        accomplishments: "",
        plansAndGoals: "",
        idp_education: "",
        idp_career: "",
        idp_professional: "",
        whyNoCFA: "",
    };

    const emptyMilestones = {
        "entered": {status:0, term:0},
        "pos": {status:0, term:0},
        "final": {status:0, term:0},
        "seminar1": {status: 0, term: 0},
        "seminar2": {status: 0, term: 0},
    };

    /** Fetches the student's most recent SAR
     * Could be this years draft or last years submission
     * Will set to empty SAR if this is student's first time
     */
    const fetchSAR = async() => {
        let foundSAR = false;
        //Look for already existing SAR
        await axios.get(`/api/sar/${CurrentUser.pid}`).then((response) => {
            if(statusIsGood(response.status)) {
                let newSAR = response.data.sar
                if(newSAR.year === currentYear && newSAR.sarStatus === 2) {
                    //Can't modify a submitted SAR
                    alert("Cannot modify your SAR once it has been submitted.");
                    window.location.href = `/sar/review/`; //Send to list of past SARs
                    return;
                }
                setSar({
                    ...emptySAR,
                    ...newSAR,
                    year: currentYear,
                    acceleratedMasters: newSAR.acceleratedMasters === null ? '' : !!newSAR.acceleratedMasters
                });
                setAdmissionTerm(newSAR.admissionTerm);
                setDegreeType(newSAR.degreeType);
                foundSAR = true;
                //Set Milestones
                setMilestones({
                    ...emptyMilestones,
                    ...Object.fromEntries(response.data.milestones.map((m) => [m.name, {status: m.status, term: m.term}]))
                });
                //Set Funding Terms
                setFundingTerms({
                    ...calcNewFTs(newSAR.admissionTerm),
                    ...response.data.fundingTerms
                });
                //Set Publications
                setPublications([...response.data.publications]);
                //Get Advisors
                let _facAdvisors = [...response.data.facultyAdvisors]
                //Filter out nonAdvisors (student didn't list them but they left a review)
                let filteredFacAdvisors = _facAdvisors.filter((fa) => fa.end >= -1);
                setFacultyAdvisors(filteredFacAdvisors);
                //Get Evals of Advisors
                axios.get(`/api/sar_evals/${newSAR.sarID}/eoas`).then((resp) => {
                    if(statusIsGood(resp.status)) {
                        //Need to reorder EoAs to match Advisor order
                        let _eoas = [...resp.data.eoa];
                        let o_eoas = [];
                        //Match them to the advisor
                        for(const fA of _facAdvisors) {
                            let _eoa = _eoas.find((e) => e.sarAdvisorID === fA.sarAdvisorID);
                            if(typeof _eoa === "undefined") {
                                o_eoas.push(null);
                            } else {
                                o_eoas.push(_eoa);
                            }
                        }
                        setEvalOfAdvisors([...o_eoas]);
                    }
                }).catch((error) => {
                    console.error(`Couldn't find EoAs for last SAR for ${CurrentUser.pid}: `, error);
                })
                //Get Dept Eval
                axios.get(`/api/sar_evals/${newSAR.sarID}/eodept`).then((resp) => {
                    if(statusIsGood(resp.status)) {
                        setDeptEval({...emptyDeptEval, ...resp.data.eodept});
                    } else {
                        setDeptEval({...emptyDeptEval});
                    }
                }).catch((error) => {
                    console.error(`Couldn't find EoDept for last SAR for ${CurrentUser.pid}: `, error);
                    setDeptEval({...emptyDeptEval});
                })
            }
        }).catch(error =>
            console.log(`Couldn't find last SAR for ${CurrentUser.pid}: `, error)
        )
        if(foundSAR) return;
        //Couldn't find a previous SAR
        fetchStudentName().then((studentName) => {
            //Create empty SAR
            setSar({...emptySAR, studentPID: CurrentUser.pid, studentName});
            //Set admissionTerm to this semester
            setAdmissionTerm(currentYear * 100 + 1);
            //Clear degreeType
            setDegreeType(null);
            //Create MS milestones
            setMilestones({
                "entered": {status:0, term:0},
                "pos": {status:0, term:0},
                "final": {status:0, term:0},
                "seminar1": {status: 0, term: 0},
                "seminar2": {status: 0, term: 0},
            });
            //Create empty Dept Eval
            setDeptEval({...emptyDeptEval});
        });
        //degreeType already set to default
    }

    async function getCurrentYear() {
        return new Promise((resolve, reject) => {
            axios.get("/api/sar/year").then((response) => {
                if(response.data.year === null) {
                    alert("Not currently accepting SARs");
                    window.location.href = "/"; //Send to list of past SARs
                } else
                    setCurrentYear(response.data.year.year);
                return resolve();
            }).catch((error) => {
                if(error.response) {
                    console.error(`Error getting open year: `, error.response);
                } else if(error.request) {
                    console.error(`Got no response to request: `, error.request);
                } else {
                    console.error(`Error: `, error)
                }
                alert(`Error getting current year, \nContact an Admin if this persists.`);
                setCurrentYear(parseInt(new Date().getFullYear()));
                return resolve();
            });
        });
    }

    /** Initial Page Loading of Data */
    useEffect(() => {
        if(!isLoaded) {
            intialize_page();
        }
    }, []);

    async function intialize_page() {
        await getCurrentYear();
        await fetchFacultyAdvisors();
        await fetchSAR();
        calcPubYears();
        setIsLoaded(true);
    }

    function handleChange(event) {
        if(!isLoaded) return;
        const {name, type, value, checked} = event.target;
        let v = type === 'checkbox' ? checked : value;
        const split = name.split("."); //Need to check if nested
        if(split.length === 1) { //Not nested
            setSar(f => ({
                ...f,
                [name]: v
            }));
        } else if(split.length === 2) { //Single Nesting
            if(isNaN(split[1])) { //Simple Nesting
                setSar(f => ({
                    ...f,
                    [split[0]]: {
                        ...f[split[0]],
                        [split[1]]: v
                    }
                }));
            } else { //Array of values
                let i = parseInt(split[1]);
                let a = sar[split[0]]; //Get a copy of the array
                //Modify the copy
                a[i] = v;
                //Overwrite with the copy
                setSar(f => ({
                    ...f,
                    [split[0]]: a
                }));
            }
        } else if(split.length === 3) { //Double Nesting
            if(isNaN(split[1]) && isNaN(split[2])) { //Simple Nesting
                setSar(f => ({
                    ...f,
                    [split[0]]: {
                        ...f[split[0]],
                        [split[1]]: {
                            ...f[split[0]][split[1]],
                            [split[2]]: v
                        }
                    }
                }));
            } else if(!isNaN(split[1]) && isNaN[2]) { //First is an array
                let i = parseInt(split[1]);
                let a = sar[split[0]]; //Get a copy of the array
                //Modify the copy
                a[i] = {...a[i], [split[2]]: v};
                //Overwrite wih the copy
                setSar(f => ({
                    ...f,
                    [split[0]]: a
                }));
            } else if(isNaN(split[1]) && !isNaN[2]) { //Second is an array
                console.error("DOUBLE NESTING WHERE SECOND IS AN ARRAY");
            } else if(!isNaN(split[1]) && !isNaN[2]) { //They're both arrays...
                console.error("DOUBLE NESTING WHERE THEY'RE BOTH ARRAYS");
            }
        }
    }

    function displayTerm(term) {
        let s = term%100 === 1 ? "Spring " : term%100 === 9 ? "Fall " : "ERROR ";
        let y = String(Math.floor(term/100));
        return s+y;
    }

/* 1. Personal Information */
    const fetchStudentName = async() => {
        return new Promise(async (resolve, reject) => {
            axios.get("/api/currentUser/name").then((response) => {
                if(statusIsGood(response.status)) {
                    return resolve(response.data.name);
                } else {
                    return resolve("No Name");
                }
            }).catch((error)=> {
                if(error.response) {
                    console.error('Error getting name:', error.response);
                } else if (error.request) {
                    console.error('Got no response to request:', error.request);
                } else {
                    console.error('Error:', error.message)
                }
                alert(`Error getting name, \nContact an admin if this persists.`);
                return resolve("Error");
            })
        })
    }

/* 3. Milestones and Progress / 5. Seminar*/
    function handleMilestones(event) {
        if(!isLoaded) return;
        const {name, type, value, checked} = event.target;
        let v = type === 'checkbox' ? checked : parseInt(value);
        let [,title,field] = name.split("."); //Break apart name
        setMilestones(m => ({
            ...m,
            [title]: {
                ...m[title],
                [field]: v
            }
        }));
    }

    /** Change milestones based on degreeType */
    useEffect(() => {
        //Set milestones
        if(degreeType === "MS") { //MS
            setMilestones(Object.fromEntries(
            Object.entries(milestones).filter(([k, v]) => 
                ["entered", "pos", "final", "seminar1", "seminar2"].includes(k)
            )));
        } else { //PhD
            setMilestones(m => ({
                "qualifier": {status:0, term:0},
                "prelim": {status:0, term:0},
                "research": {status:0, term:0},
                ...m,
            }));
        }
    }, [degreeType]);

/* 6. Funding */
    /** Add funding terms between admission and current semester (Spr 20XX) */
    useEffect(() => {
        setFundingTerms(calcNewFTs(admissionTerm));
    }, [admissionTerm]);
    
    function calcNewFTs(_admissionTerm) {
        if(
            _admissionTerm === 0 || //Unset
            Math.floor(_admissionTerm / 100) === 0 || //No Year
            _admissionTerm % 100 === 0 //No Semester
        ) return {};
        //Separate out the admission semester and year
        let s1 = _admissionTerm % 100;
        let y1 = Math.floor(_admissionTerm/100);
        //Calculate the current semester and year
        let s2 = 1; //SAR is always in Spring
        let y2 = currentYear;
        //Prep the dependencies
        let ss = [1,9]; //List of possible semesters
        let si = ss.indexOf(s1); //Starting point for the semester roll thru
        let terms = []; //List of terms
        //Calculate Every Term Between Admission and Current Term
        while(s1 <= s2 || y1 < y2) {
            terms.push(y1 * 100 + s1); //Add the current iteration
            si += 1; //Iterate the semster index
            if(si >= 2) {//Reached end of semsters
                y1++; //Increment year
                si = 0; //Reset semester index
            }
            s1 = ss[si]; //Iterate the semester
        }
        //Loop through the terms
        let newfTs = {}
        let fTKeys = Object.keys(fundingTerms).map((ftk) => parseInt(ftk));
        terms.forEach((term) => { //Filter out the unneeded and add the new
            if(fTKeys.includes(term)) //Carry over
                newfTs[term] = fundingTerms[term];
            else //Add new term
                newfTs[term] = {funds:[], details:""};
        });
        return newfTs;
    }

    function addFunding(term) {
        setFundingTerms(fts => ({
            ...fts,
            [term]: {
                funds: [...fts[term].funds, {type:"", details:""}],
                details: fts[term].details || ""
            }
        }))
    }

    function dropFunding(term, index) {
        setFundingTerms(fts => ({
            ...fts,
            [term]: {
                details: fts[term].details,
                funds: fts[term].funds.filter((_,i) => index != i)
            } 
            /* 
            Object.fromEntries(
                Object.entries(fts[term].funds)
                    
                    (k,v) =>
                    fts[term]?.funds.filter((_,i) => index != i)
                )
            )*/
        }))
    }

    function handleFundingChange(event) {
        // fundingTerm = {202401:{funds:[], details:""},}
        const {name, type, value, checked} = event.target;
        let v = type === 'checkbox' ? checked : value;
        let [term, index, extra] = name.split("."); //Need to check if nested
        term = parseInt(term);
        if(index == "details") { //Name is format of <term>.<details>
            setFundingTerms(fts => ({
                ...fts,
                [term]: {
                    funds: fts[term].funds,
                    details: v,
                }
            }))
        } else { //Name is format of <term>.<index>.<type/details>
            index = parseInt(index);
            setFundingTerms(fts => ({
                ...fts,
                [term]: {
                    funds: fts[term].funds.map((fund, i) => {
                        if(index == i) {
                            return {
                                ...fund,
                                [extra]: v,
                            };
                        } else return fund;
                    }),
                    details: fts[term].details
                }
            }));
        }
    }

/* 7. Publication Record at VT */
    /** Creates an array of the last 10 years */
    function calcPubYears() {
        let pubYears = [];
        for(let i = currentYear-10; i <= currentYear; i++) {
            pubYears.push(i);
        }
        setPublicationYears(pubYears);
    }
    /** Handles changes to the publication object */
    function handlePublication(event) {
        const {name, value} = event.target;
        let v = isNaN(value) || value === "" ? value : parseInt(value);
        let [, index, field] = name.split(".");
        index = parseInt(index);
        setPublications(publications.map((pub, i) => {
            if(i == index)
                return {...pub, [field]: v}
            else
                return pub;
        }));
    }
    /** Adds a new entry to the publication object */
    function addPublication() {
        setPublications([
            ...publications,
            {
                year: currentYear,
                status: 0,
                doi: "",
                description: "",
            }
        ]);
    }
    /** Removes an entry from the publication object */
    function dropPublication(index) {
        setPublications(publications.filter((_, i) => i != index));
    }

/* Evaluation of Department */
    const emptyDeptEval = {
        inclusive_value: null,
        inclusive_text: "",
        additions: "",
    };

    const handleDeptEval = (event) => {
        if(!isLoaded) return;
        const {name, value} = event.target;
        let v = isNaN(value) || value === "" ? value : parseInt(value);
        let [, field] = name.split(".");
        if(deptEval[field] === v) return;
        setDeptEval({
            ...deptEval,
            [field]: v
        });
    }

/* Faculty Advisor(s) */
    /** Fetches all of the faculty advisors */
    const fetchFacultyAdvisors = async () => {
        axios.get("/api/faculty").then((response) => {
            setAllFaculty(response.data.faculty);
        }).catch((error) => {
            if (error.response) {
                console.error('Error getting faculty:', error.response);
            } else if (error.request) {
                console.error('Got no response to request:', error.request);
            } else {
                console.error('Error:', error.message)
            }
            alert(`Error getting faculty, \nContact an admin if this persists.`);
            setAllFaculty([]);
        });
    }

    function handleFacultyAdvisors(event) {
        if(!isLoaded) return;
        const {name, type, value, checked} = event.target;
        let v = type === 'checkbox' ? checked : value;
        let [,index,field] = name.split("."); //Break apart name
        index = parseInt(index);
        if(field === "advisorPID") { //Need to fetch first and last name
            let [f] = allFaculty.filter((fac) => fac.pid === v);
            setFacultyAdvisors(facultyAdvisors.map((fa, i) => {
                if(i == index)
                    return {...fa, advisorPID: v, first: f?.first, last: f?.last}
                else
                    return fa;
            }));
        } else {
            setFacultyAdvisors(facultyAdvisors.map((fa, i) => {
                if(i == index)
                    return {...fa, [field]: v}
                else
                    return fa;
            }));
        }
        // If setting to current advisor need to ensure has an eval
        if(field === "end" && v === -1 && !evalOfAdvisors[index]) {
            let _EoA = [...evalOfAdvisors];
            _EoA[index] = {...emptyEvalOfAdvisor};
            setEvalOfAdvisors(_EoA);
            //setEvalOfAdvisors(evalOfAdvisors.map((eoa, i) => {
            //    if(i === index) return {...emptyEvalOfAdvisor};
            //    else return eoa;
            //}))
        }
    }

    function addFacAdvisor() {
        setFacultyAdvisors([
            ...facultyAdvisors,
            {
                advisorPID: "",
                first: "",
                last: "",
                start: 0,
                end: 0,
            }
        ]);
    }

    function dropFacAdvisor(index) {
        setFacultyAdvisors(facultyAdvisors.filter((_,i) => i != index));
        //Also need to remove associated evaluation
        setEvalOfAdvisors(evalOfAdvisors.filter((_,i) => i != index));
    }

    /** If they don't have a current advisor, need to ask why */
    useEffect(() => {
        if(facultyAdvisors.filter((fa) => fa.end === -1).length > 0) {
            setHasCurrentFA(true);
            handleChange({target:{
                name: 'whyNoCFA',
                type: 'text',
                value: "",
                checked: false
            }});
        } else {
            setHasCurrentFA(false);
        }
    }, [facultyAdvisors])

/* Evaluation of Advisor */
    const emptyEvalOfAdvisor = {
        meeting_frequency: "",
        timely_feedback_value: null,
        timely_feedback_text: "",
        professional_development_value: null,
        professional_development_text: "",
        approachability_value: null,
        approachability_text: "",
        expectations_and_goals_value: null,
        expectations_and_goals_text: "",
        overall_satisfaction_value: null,
        overall_satisfaction_text: "",
        additional_info: "",
        follow_up: null
    };

    /** Modify the evalOfAdvisors array state */
    const handleEoA = (event) => {
        if(!isLoaded) return;
        const {name, type, value, checked} = event.target;
        let v = type === 'checkbox' ? checked : isNaN(value) || value === "" ? value : parseInt(value);
        let [,index,field] = name.split(".");
        index = parseInt(index);
        if(evalOfAdvisors[index][field] === v) return;
        setEvalOfAdvisors(evalOfAdvisors.map((eoa, i) => {
            if(i === index) return {...eoa, [field]: v};
            else return eoa;
        }));
    };

    /** Add an evaluation for a non-current advisor */
    const addEoA = (index) => {
        // Only add if there's not already an eval here (don't want to overwrite)
        if(!evalOfAdvisors[index]) {
            let _EoA = [...evalOfAdvisors];
            _EoA[index] = {...emptyEvalOfAdvisor};
            setEvalOfAdvisors(_EoA);
            setNewEoA(-1);
            //handle EoA Errors
            let _eoaErrors = [...eoaErrors];
            _eoaErrors[index] = 0;
            setEoAErrors(_eoaErrors);
        } else
            alert(`Cannot add eval ${index}, there's already an eval there`);
    };

    /** Drop an evaluation for a non-current advisor */
    const dropEoA = (index) => {
        // Only drop if they're not a current advisor
        if(facultyAdvisors[index].end !== -1) {
            setEvalOfAdvisors(evalOfAdvisors.map((eoa, i) => {
                if(i === index) return undefined; //unset
                else return eoa;
            }));
            //handle EoA Errors
            setEoAErrors(eoaErrors.map((ee, i) => {
                if(i === index) return 0;
                else return ee;
            }))
        }
        else
            alert(`Cannot drop eval ${index}, for a current advisor`);
    };

    const handleEoAErrors = (index, count) => {
        if(!isLoaded) return;
        let _eoaErrors = [...eoaErrors];
        _eoaErrors[index] = count;
        setEoAErrors(_eoaErrors);
    }

    /**
     * Function to save/submit the form
     * @param {Boolean} isSubmit - Is this a submission (true) or a save (false) [defaults to false] 
     */
    const onSubmit = (isSubmit = false)  => {
        if(isSubmit) { //Perform Validation
            setValidating(true);
            let e = validateForm2();
            if(e > 0) {
                console.log(`[onSubmit] Found ${e} errors`);
                alert("Failed to validate your submission!");
                return;
            }
            //Double check they actually want to submit
            if(!window.confirm("Once submitted you will not be able to make further changes, are you sure you would like to submit?"))
                return;
        } else if(lengthCheck() > 0) {
            alert("At least one textbox is overfilled, your SAR cannot be saved until you fix it.");
            return;
        }
        let b = {
            ...sar,
            degreeType,
            admissionTerm,
            facultyAdvisors,
            milestones,
            fundingTerms,
            publications,
            deptEval,
            evalOfAdvisors,
            sarStatus: isSubmit ? 2 : 1,
        }
        axios.post(`/api/sar/${currentYear}/${sar.studentPID}`, {...b}).then((response) => {
            if(statusIsGood(response.status)) {
                alert(response.data.message);
                if(isSubmit) {
                    window.location.href = `/sar/review/${currentYear}/${CurrentUser.pid}`; //Send to list of past SARs
                    return;
                }
            } else {
                console.error(response.errors);
                alert(response.message);
            };
        }).catch((error) => {
            if(Object.hasOwn(error.response, 'data')) {
                console.error(error.response);
                if(error.response.status === 401) {
                    alert("An error has occured with your connection and you have been logged out. "+
                        "To keep your unsaved work, please open the site in a new tab/window, log in "+
                        "(depending on how you reopen the site you may need to refresh the new tab/window to be prompted)"+
                        ", and then try resubmitting. Contact an admin if this persists.");
                } else {
                    alert(error.response.data.message)
                }
            } else {
                alert("Error saving SAR, \nContact an admin if this persists.");
                console.error(error.response);
            }
        });
    }

    const showInfo = () => {
        console.log({
            ...sar,
            degreeType,
            admissionTerm,
            facultyAdvisors,
            milestones,
            fundingTerms,
            publications,
            deptEval,
            evalOfAdvisors
        })
    }

    const lengthCheck = () => {
        let newErrors = {}
        //6. Funding
        newErrors.funding = {}
        newErrors.fundingTerm = {}
        Object.entries(fundingTerms).forEach(([term, fundingTerm]) => {
            fundingTerm.funds.forEach((fund, index) => {
                if(fund.details.length > 1000) {
                    if(newErrors.funding[term] === undefined)
                        newErrors.funding[term] = []
                    newErrors.funding[term][index] = `Answer must be 1000 characters or less`;
                }
            });
            if(fundingTerm.details.length > 1000) {
                newErrors.fundingTerm[term] = `Answer must be 1000 characters or less`;
            }
        });
        if(Object.keys(newErrors.funding) < 1) delete newErrors.funding;
        if(Object.keys(newErrors.fundingTerm) < 1) delete newErrors.fundingTerm;
        //7. Publications
        newErrors.publication = [];
        let tempPub = {}
        publications.forEach((publication, index) => {
            if(publication.description.length > 2000)
                tempPub.description = `Description must be 2000 characters or less.`;
            if(Object.keys(tempPub).length > 0) {
                newErrors.publication[index] = {...tempPub}; //Copy the errors
                tempPub = {}; //Reset tempPub
            }
        });
        if(newErrors.publication.length < 1) delete newErrors.publication;
        //8-12. Answer Length checks
        if(sar.presentations.length > 2000)
            newErrors.presentations = `Answer must be 2000 characters or less`;
        if(sar.internships.length > 2000)
            newErrors.internships = `Answer must be 2000 characters or less`;
        if(sar.activities.length > 2000)
            newErrors.activities = `Answer must be 2000 characters or less`;
        if(sar.accomplishments.length > 2000)
            newErrors.accomplishments = `Answer must be 2000 characters or less`;
        if(sar.plansAndGoals.length > 2000)
            newErrors.plansAndGoals = `Answer must be 2000 characters or less`;
        //13. IDP
        if(sar.idp_education.length > 2000)
            newErrors.idp_education = `Answer must be 2000 characters or less`;
        if(sar.idp_career.length > 2000)
            newErrors.idp_career = `Answer must be 2000 characters or less`;
        if(sar.idp_professional.length > 2000)
            newErrors.idp_professional = `Answer must be 2000 characters or less`;
        //DeptEval
        if(deptEval?.inclusive_text?.length > 2000)
            newErrors.deptEval_inclusive_text = `Answer must be 2000 characters or less`;
        if(deptEval?.additions?.length > 2000)
            newErrors.deptEval_additions = `Answer must be 2000 characters or less`;
        //Advising
        if(!hasCurrentFA && (sar.whyNoCFA.length > 2000))
            newErrors.whyNoCFA = `Answer must be 2000 characters or less`;
        let eoaErrorCount = eoaErrors.reduce(
            (tc, cv) => tc + (cv || 0),
            0
        );
        console.log({...newErrors});
        console.log({eoaErrors});
        setErrors(newErrors);
        return Object.keys(newErrors).length + eoaErrorCount; 
    }

    const validateForm2 = () => {
        let newErrors = {};
        //1. Personal Information
        if(sar.studentName === "")
            newErrors.studentName = `Must provide a name`;
        //2. Degree Program
        if(!degreeType)
            newErrors.degreeType = `Must select a Degree Program`;
        if(degreeType === "MS" && sar.acceleratedMasters === "")
            newErrors.acceleratedMasters = `You must answer this question`;
        if(admissionTerm%100 < 1 || Math.floor(admissionTerm/100) < 1)
            newErrors.admissionTerm = `Must provide an admission term.`;
        if(!sar.enrollment)
            newErrors.enrollment = `Must select an Enrollment Status`;
        //3. Milestones and Progress & 5. Department Requirements
        newErrors.milestones = {};
        Object.entries(milestones).forEach(([k, v]) => {
            if(!checkForValidTerm(v.term))
                newErrors.milestones[k] = `Must provide a term`;
            else if(v.term < currentYear*100+1 && v.status === 0)
                newErrors.milestones[k] = `Cannot be planned for a past term`;
            else if(v.term > currentYear*100+1 && v.status === 1)
                newErrors.milestones[k] = `Cannot be completed in a future term`;
        });
        if(Object.keys(newErrors.milestones) < 1) delete newErrors.milestones;
        //4. Ethics Requirements may not be completed
        //5. Seminars
        if(!newErrors?.milestones?.seminar1 || !newErrors?.milestones?.seminar2) {
            if(milestones?.seminar1?.term > milestones?.seminar2?.term)
                newErrors.seminar =`"First Seminar" must come before "Second Seminar"`;
            else if(milestones?.seminar1?.term === milestones?.seminar2?.term)
                newErrors.seminar = `You cannot take both "First Seminar" and "Second Seminar" in the same Term`;
        }
        //6. Funding
        newErrors.funding = {}
        newErrors.fundingTerm = {}
        Object.entries(fundingTerms).forEach(([term, fundingTerm]) => {
            fundingTerm.funds.forEach((fund, index) => {
                if(fund.type === "") {
                    if(fundingTerm.funds.length === 1) {
                        if(newErrors.funding[term] === undefined)
                            newErrors.funding[term] = []
                        newErrors.funding[term][0] = `Must set at least one funding type or set to "Not Enrolled"`;
                    } else {
                        if(newErrors.funding[term] === undefined)
                            newErrors.funding[term] = []
                        newErrors.funding[term][index] = `Must either set a funding type or delete the funding`;
                    }
                } else if(fund.details === "") {
                    if(newErrors.funding[term] === undefined)
                        newErrors.funding[term] = []
                    newErrors.funding[term][index] = `Must provide details on the funding source`;
                } else if(fund.details.length > 1000) {
                    if(newErrors.funding[term] === undefined)
                        newErrors.funding[term] = []
                    newErrors.funding[term][index] = `Answer must be 1000 characters or less`;
                }
            });
            if(fundingTerm.details.length > 1000) {
                newErrors.fundingTerm[term] = `Answer must be 1000 characters or less`;
            }
        });
        if(Object.keys(newErrors.funding) < 1) delete newErrors.funding;
        if(Object.keys(newErrors.fundingTerm) < 1) delete newErrors.fundingTerm;
        //7. Publications
        newErrors.publication = [];
        let tempPub = {}
        publications.forEach((publication, index) => {
            //Needs a year
            if(isNaN(publication.year) || publication.year === "")
                tempPub.year = `Publication must have a year associated with it. If still in preparation should be the current year.`;
            //Cannot be in preparation (0) for a past year
            else if(publication.year < currentYear && publication.status === 0)
                tempPub.year = `Publication cannot be in preparation for a past year. The year should be the current year or the status should be updated.`;
            //Needs a description
            if(publication.description === "" || publication.description.trim() === '<p><br></p>')
                tempPub.description = `Publication must have a description.`;
            else if(publication.description.length > 2000)
                tempPub.description = `Description must be 2000 characters or less.`;
            if(Object.keys(tempPub).length > 0) {
                newErrors.publication[index] = {...tempPub}; //Copy the errors
                tempPub = {}; //Reset tempPub
            }
        });
        if(newErrors.publication.length < 1) delete newErrors.publication;
        //8-12. Answer Length checks
        if(sar.presentations.length > 2000)
            newErrors.presentations = `Answer must be 2000 characters or less`;
        if(sar.internships.length > 2000)
            newErrors.internships = `Answer must be 2000 characters or less`;
        if(sar.activities.length > 2000)
            newErrors.activities = `Answer must be 2000 characters or less`;
        if(sar.accomplishments.length > 2000)
            newErrors.accomplishments = `Answer must be 2000 characters or less`;
        if(sar.plansAndGoals.length > 2000)
            newErrors.plansAndGoals = `Answer must be 2000 characters or less`;
        //13. IDP
        if(sar.idp_education === "" || sar.idp_education.trim() === '<p><br></p>')
            newErrors.idp_education = `You must provide your Planned Educational Goals.`;
        else if(sar.idp_education.length > 2000)
            newErrors.idp_education = `Answer must be 2000 characters or less`;
        if(sar.idp_career === "" || sar.idp_career.trim() === '<p><br></p>')
            newErrors.idp_career = `You must provide your Planned Career Exploration.`;
        else if(sar.idp_career.length > 2000)
            newErrors.idp_career = `Answer must be 2000 characters or less`;
        if(sar.idp_professional === "" || sar.idp_professional.trim() === '<p><br></p>')
            newErrors.idp_professional = `You must provide your Planned Professional Development.`;
        else if(sar.idp_professional.length > 2000)
            newErrors.idp_professional = `Answer must be 2000 characters or less`;
        //DeptEval
        if(deptEval.inclusive_value === null)
            newErrors.deptEval_inclusive_value = `You must answer this question.`
        if(deptEval.inclusive_text.length > 2000)
            newErrors.deptEval_inclusive_text = `Answer must be 2000 characters or less`;
        if(deptEval.additions.length > 2000)
            newErrors.deptEval_additions = `Answer must be 2000 characters or less`;
        //Advising
        if(!hasCurrentFA && (sar.whyNoCFA === "" || sar.whyNoCFA.trim() === '<p><br></p>'))
            newErrors.whyNoCFA = `Must explain why you don't have a current advisor.`;
        else if(!hasCurrentFA && (sar.whyNoCFA.length > 2000))
            newErrors.whyNoCFA = `Answer must be 2000 characters or less`;
        let eoaErrorCount = eoaErrors.reduce(
            (tc, cv) => tc + (cv || 0),
            0
        );
        console.log(newErrors);
        setErrors(newErrors);
        return Object.keys(newErrors).length + eoaErrorCount; 
    }

    const checkForValidTerm = (term) => {
        return term === -1 || (term%100 > 0 && Math.floor(term/100) > 0);
    }

    return (
        <div className="page-body">
            {isLoaded ?
            <>
                <h1>Student Activity Report</h1>
                <form>
                    <fieldset style={{borderRadius: '0.5em'}}>
                        <legend>1. Personal Information</legend>
                        <div>
                            <p htmlFor="studentName" className="form-label">
                                Student Name:
                            </p>
                            <div className="form-options-div">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="studentName"
                                    name="studentName"
                                    value={sar.studentName}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-options-div">
                                <span className="feedback">{errors.studentName}</span>
                            </div>
                        </div>
                        <div>
                            <p htmlFor="studentPID" className="form-label">
                                Student PID:
                            </p>
                            <div className="form-options-div">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="studentPID"
                                    name="studentPID"
                                    value={sar.studentPID || "hokiebird"}
                                    onChange={null}
                                    readOnly={true}
                                />
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend>2. Degree Program</legend>
                        <div>
                            <p className="form-label">What degree program are you in?</p>
                            <div className="form-options-div">
                                <div>
                                    <input
                                        type="radio"
                                        id="degree-MS"
                                        name="degree"
                                        value="MS"
                                        checked={degreeType === "MS"}
                                        onChange={() => setDegreeType("MS")}
                                    />
                                    <label
                                        htmlFor="degree-MS"
                                        className="form-radio-options"
                                    >Master of Science (MS)</label>
                                </div>
                                <div>
                                    <input
                                        type="radio"
                                        id="degree-PhD"
                                        name="degree"
                                        value="PhD"
                                        checked={degreeType === "PhD"}
                                        onChange={() => setDegreeType("PhD")}
                                    />
                                    <label
                                        htmlFor="degree-PhD"
                                        className="form-radio-options"
                                    >Doctor of Philosophy (PhD)</label>
                                </div>
                                <span className="feedback">{errors.degreeType}</span>
                            </div>
                            {degreeType === "MS" && <div>
                                <p className="form-label">Are you in the accelerated Master's Program?</p>
                                <div className="form-options-div">
                                    <select
                                        className="form-select"
                                        id="acceleratedMasters"
                                        name="acceleratedMasters"
                                        value={sar.acceleratedMasters}
                                        onChange={(e) => handleChange({target:{
                                            name: 'acceleratedMasters',
                                            type:'checkbox',
                                            checked: e.target.value === 'true'
                                        }})}
                                    >
                                        <option></option>
                                        <option value={false}>No</option>
                                        <option value={true}>Yes</option>
                                    </select>
                                    <span className="feedback">{errors.acceleratedMasters}</span>
                                </div>
                            </div>}
                            
                            <div>
                                <p>What semester were you admitted to your current degree program?</p>
                                <div className="form-options-div">
                                    <TermSelector2
                                        title={`sarAdmissionTerm`}
                                        term={admissionTerm}
                                        termSetter={setAdmissionTerm}
                                        yearMin={currentYear-10}
                                        yearMax={currentYear}
                                    />
                                    <span className="feedback">{errors.admissionTerm}</span>
                                </div>
                            </div>
                            <div>
                                <p>Are you a Full-Time student or Part-Time student?</p>
                                <div className="form-options-div">
                                    <div>
                                        <input
                                            type="radio"
                                            id="enrollment-Full"
                                            name="enrollment"
                                            value="full"
                                            checked={sar.enrollment === "full"}
                                            onChange={handleChange}
                                        />
                                        <label
                                            htmlFor="enrollment-Full"
                                            className="form-radio-options"
                                        >Full-Time</label>
                                    </div>
                                    <div>
                                        <input
                                            type="radio"
                                            id="enrollment-Part"
                                            name="enrollment"
                                            value="part"
                                            checked={sar.enrollment === "part"}
                                            onChange={handleChange}
                                        />
                                        <label
                                            htmlFor="enrollment-Part"
                                            className="form-radio-options"
                                        >Part-Time</label>
                                    </div>
                                    <span className="feedback">{errors.enrollment}</span>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend>3. Milestones and Progress</legend>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Milestone</th>
                                    <th>Status</th>
                                    <th>Term</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Entered Program</td>
                                    <td>
                                        <select
                                            id={`milestones.entered.status`}
                                            name={`milestones.entered.status`}
                                            className="form-select"
                                            value={milestones?.entered?.status}
                                            onChange={handleMilestones}
                                        >
                                            <option value={0}>Planned</option>
                                            <option value={1}>Completed</option>
                                        </select>
                                    </td>
                                    <td>
                                        <TermSelector2
                                            title={`milestones.entered.term`}
                                            term={milestones?.entered?.term || 0}
                                            termSetter={function(term) {
                                                handleMilestones({target:{
                                                    name: `milestones.entered.term`,
                                                    type: 'text',
                                                    value: term,
                                                    checked: false,
                                                }});
                                            }}
                                            yearMin={currentYear-10}
                                            yearMax={currentYear+10}
                                            hasSummer={true}
                                        />
                                        {!!errors.milestones?.entered &&
                                            <span className="feedback">{errors.milestones?.entered}</span>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>Plan of Study filed{degreeType === "PhD" && ' (due by the end of your 3rd semester)'}</td>
                                    <td>
                                        <select
                                            id={`milestones.pos.status`}
                                            name={`milestones.pos.status`}
                                            className="form-select"
                                            value={milestones?.pos?.status}
                                            onChange={handleMilestones}
                                        >
                                            <option value={0}>Planned</option>
                                            <option value={1}>Completed</option>
                                        </select>
                                    </td>
                                    <td>
                                        <TermSelector2
                                            title={`milestones.pos.term`}
                                            term={milestones?.pos?.term || 0}
                                            termSetter={function(term) {
                                                handleMilestones({target:{
                                                    name: `milestones.pos.term`,
                                                    type: 'text',
                                                    value: term,
                                                    checked: false,
                                                }});
                                            }}
                                            yearMin={currentYear-10}
                                            yearMax={currentYear+10}
                                            hasSummer={true}
                                        />
                                        {!!errors.milestones?.pos &&
                                            <span className="feedback">{errors.milestones?.pos}</span>
                                        }
                                    </td>
                                </tr>
                                {degreeType === "PhD" && <>
                                    <tr>
                                        <td>Qualifier Exam (due at the end of your 2nd year)</td>
                                        <td>
                                            <select
                                                id={`milestones.qualifier.status`}
                                                name={`milestones.qualifier.status`}
                                                className="form-select"
                                                value={milestones?.qualifier?.status}
                                                onChange={handleMilestones}
                                            >
                                                <option value={0}>Planned</option>
                                                <option value={1}>Completed</option>
                                            </select>
                                        </td>
                                        <td>
                                            <TermSelector2
                                                title={`milestones.qualifier.term`}
                                                term={milestones.qualifier?.term}
                                                termSetter={function(term) {
                                                    handleMilestones({target:{
                                                        name: `milestones.qualifier.term`,
                                                        type: 'text',
                                                        value: term,
                                                        checked: false,
                                                    }});
                                                }}
                                                yearMin={currentYear-10}
                                                yearMax={currentYear+10}
                                                hasSummer={true}
                                            />
                                            {!!errors.milestones?.qualifier &&
                                                <span className="feedback">{errors.milestones?.qualifier}</span>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Preliminary Exam (due at the end of your 4th year)</td>
                                        <td>
                                            <select
                                                id={`milestones.prelim.status`}
                                                name={`milestones.prelim.status`}
                                                className="form-select"
                                                value={milestones?.prelim?.status}
                                                onChange={handleMilestones}
                                            >
                                                <option value={0}>Planned</option>
                                                <option value={1}>Completed</option>
                                            </select>
                                        </td>
                                        <td>
                                            <TermSelector2
                                                title={`milestones.prelim.term`}
                                                term={milestones.prelim?.term}
                                                termSetter={function(term) {
                                                    handleMilestones({target:{
                                                        name: `milestones.prelim.term`,
                                                        type: 'text',
                                                        value: term,
                                                        checked: false,
                                                    }});
                                                }}
                                                yearMin={currentYear-10}
                                                yearMax={currentYear+10}
                                                hasSummer={true}
                                            />
                                            {!!errors.milestones?.prelim &&
                                                <span className="feedback">{errors.milestones?.prelim}</span>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Research Defense (5th year)</td>
                                        <td>
                                            <select
                                                id={`milestones.research.status`}
                                                name={`milestones.research.status`}
                                                className="form-select"
                                                value={milestones?.research?.status}
                                                onChange={handleMilestones}
                                            >
                                                <option value={0}>Planned</option>
                                                <option value={1}>Completed</option>
                                            </select>
                                        </td>
                                        <td>
                                            <TermSelector2
                                                title={`milestones.research.term`}
                                                term={milestones.research?.term}
                                                termSetter={function(term) {
                                                    handleMilestones({target:{
                                                        name: `milestones.research.term`,
                                                        type: 'text',
                                                        value: term,
                                                        checked: false,
                                                    }});
                                                }}
                                                yearMin={currentYear-10}
                                                yearMax={currentYear+10}
                                                hasSummer={true}
                                            />
                                            {!!errors.milestones?.research &&
                                                <span className="feedback">{errors.milestones?.research}</span>
                                            }
                                        </td>
                                    </tr>
                                </>}
                                <tr>
                                    <td>Final Defense{degreeType === "PhD" && ' (5th year)'}</td>
                                    <td>
                                        <select
                                            id={`milestones.final.status`}
                                            name={`milestones.final.status`}
                                            className="form-select"
                                            value={milestones?.final?.status}
                                            onChange={handleMilestones}
                                        >
                                            <option value={0}>Planned</option>
                                            <option value={1}>Completed</option>
                                        </select>
                                    </td>
                                    <td>
                                        <TermSelector2
                                            title={`milestones.final.term`}
                                            term={milestones?.final?.term || 0}
                                            termSetter={function(term) {
                                                handleMilestones({target:{
                                                    name: `milestones.final.term`,
                                                    type: 'text',
                                                    value: term,
                                                    checked: false,
                                                }});
                                            }}
                                            yearMin={currentYear-10}
                                            yearMax={currentYear+10}
                                            hasSummer={true}
                                        />
                                            {!!errors.milestones?.final &&
                                                <span className="feedback">{errors.milestones?.final}</span>
                                            }
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>
                                        Note: The CS Graduate Office strongly recommends that students apply for their degree in HokieSpa as soon as their Plan of Study is approved by the Grad School.
                                        <a href="https://onecampus.vt.edu/task/all/application-for-degree" target="_blank">Click Here To Apply!</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </fieldset>
                    <fieldset>
                        <legend>4. Ethics Requirements</legend>
                        <div className="form-options-div">
                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    id="ethics_rcr"
                                    name="ethics_rcr"
                                    checked={sar.ethics_rcr}
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label
                                    htmlFor="ethics_rcr"
                                    className="form-check-label"
                                >
                                    Completed Responsible Conduct of Research Training?
                                </label>
                            </div>
                        </div>
                        {!!errors.ethics_rcr &&
                            <div className="form-options-div">
                                <span className="feedback">{errors.ethics_rcr}</span>
                            </div>
                        }
                        <div className="form-options-div">
                            <div className="form-check">
                                <input
                                    type="checkbox"
                                    id="ethics_coi"
                                    name="ethics_coi"
                                    checked={sar.ethics_coi}
                                    onChange={handleChange}
                                    className="form-check-input"
                                />
                                <label
                                    htmlFor="ethics_coi"
                                    className="form-check-label"
                                >
                                    Completed Conflict of Interest Training?
                                </label>
                            </div>
                        </div>
                        {!!errors.ethics_coi &&
                            <div className="form-options-div">
                                <span className="feedback">{errors.ethics_coi}</span>
                            </div>
                        }
                    </fieldset>
                    <fieldset>
                        <legend>5. Department Requirements - CS Graduate Seminar</legend>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Status</th>
                                    <th>Term</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>CS 5944</td>
                                    <td>
                                        <select
                                            id={`milestones.seminar1.status`}
                                            name={`milestones.seminar1.status`}
                                            className="form-select"
                                            value={milestones?.seminar1?.status}
                                            onChange={handleMilestones}
                                        >
                                            <option value={0}>Planned</option>
                                            <option value={1}>Completed</option>
                                        </select>
                                    </td>
                                    <td>
                                        <TermSelector2
                                            title={`milestones.seminar1.term`}
                                            term={milestones?.seminar1?.term || 0}
                                            termSetter={function (term) {
                                                handleMilestones({target:{
                                                    name: `milestones.seminar1.term`,
                                                    type: 'text',
                                                    value: term,
                                                    checked: false
                                                }});
                                            }}
                                            yearMin={currentYear-10}
                                            yearMax={currentYear+10}
                                        />
                                        {!!errors.milestones?.seminar1 &&
                                            <span className="feedback">{errors.milestones?.seminar1}</span>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>CS 5944</td>
                                    <td>
                                        <select
                                            id={`milestones.seminar2.status`}
                                            name={`milestones.seminar2.status`}
                                            className="form-select"
                                            value={milestones?.seminar2?.status || 0}
                                            onChange={handleMilestones}
                                        >
                                            <option value={0}>Planned</option>
                                            <option value={1}>Completed</option>
                                        </select>
                                    </td>
                                    <td>
                                        <TermSelector2
                                            title={`milestones.seminar2.term`}
                                            term={milestones?.seminar2?.term || 0}
                                            termSetter={function (term) {
                                                handleMilestones({target:{
                                                    name: `milestones.seminar2.term`,
                                                    type: 'text',
                                                    value: term,
                                                    checked: false
                                                }});
                                            }}
                                            yearMin={currentYear-10}
                                            yearMax={currentYear+10}
                                        />
                                        {!!errors.milestones?.seminar2 && 
                                            <span className="feedback">{errors.milestones?.seminar2}</span>
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {!!errors.seminar && <div className="form-options-div">
                            <span className="feedback">{errors.seminar}</span>
                        </div>}
                    </fieldset>
                    <fieldset>
                        <legend>6. Funding</legend>
                        <table className="table fundingTable">
                            <thead>
                                <tr>
                                    <th className="termColumn">Term</th>
                                    <th className="typeColumn">Type</th>
                                    <th>Details</th>
                                    <th className="actionColumn">Actions</th>
                                </tr>
                            </thead>
                            {Object.keys(fundingTerms).length === 0 ?
                                <td colSpan={4}>Please select your admission term first.</td>
                            : Object.entries(fundingTerms).map(([term, funding]) => (
                                <tbody key={term}>
                                    {funding.funds.length === 0 ?
                                    <tr key={term}>
                                        <td>{displayTerm(term)}</td>
                                        <td colSpan={3}>
                                            <button
                                                type="button"
                                                className="btn btn-success"
                                                onClick={addFunding(term)}
                                            >
                                                Add Funding
                                            </button>
                                        </td>
                                    </tr>
                                    :
                                    <>
                                    {funding.funds.map((fund, index) => (
                                    <tr key={term+index}>
                                        {index === 0 && //First row needs the term to drop down to the others
                                            <td
                                                rowSpan={funding.funds.length + 1}
                                                className="fundingTerm"
                                            >{displayTerm(term)}</td>
                                        }
                                        <td className="fundingLeft">
                                            <select
                                                name={`${term}.${index}.type`}
                                                className="form-select"
                                                value={fund.type}
                                                onChange={handleFundingChange}
                                            >
                                                <option></option>
                                                <option>GRA</option>
                                                <option>GTA</option>
                                                <option>GA</option>
                                                <option>1/2 GRA</option>
                                                <option>1/2 GTA</option>
                                                <option>Fellowship</option>
                                                <option>Self-Funded</option>
                                                <option>Government</option>
                                                <option>Company</option>
                                                <option>Not Enrolled</option>
                                                <option>Other</option>
                                            </select>
                                            {!!errors.funding?.[term]?.[index] &&
                                                <span className="feedback">{errors.funding[term][index]}</span>
                                            }
                                        </td>
                                        <td>
                                            <textarea
                                                name={`${term}.${index}.details`}
                                                className="form-control"
                                                value={fund.details}
                                                onChange={handleFundingChange}
                                                rows={3}
                                            />
                                        </td>
                                        <td>
                                            <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() => dropFunding(term,index)}
                                            >Delete</button>
                                            <div>
                                                <Tooltip title="Styling takes up extra characters">
                                                    <span style={{color: fund.details?.length > 1000 && "red", fontWeight: fund.details?.length >= 900 && "bold"}}>{fund.details?.length}/1000*</span>
                                                </Tooltip>
                                            </div>
                                        </td>
                                    </tr>))}
                                    </>}
                                    <tr>
                                        <td colSpan={2} className="fundingLeft">
                                            <textarea
                                                name={`${term}.details`}
                                                className="form-control"
                                                placeholder="Additional Comments on Semester Funding"
                                                value={funding.details}
                                                onChange={handleFundingChange}
                                                rows={3}
                                            />
                                            {!!errors.fundingTerm?.[term] &&
                                                <span className="feedback">{errors.fundingTerm[term]}</span>
                                            }
                                        </td>
                                        <td>
                                            <button
                                                type="button"
                                                className="btn btn-success"
                                                onClick={() => addFunding(term)}
                                            >
                                                Add Funding
                                            </button>
                                            <div>
                                                <Tooltip title="Styling takes up extra characters">
                                                    <span style={{color: funding.details?.length > 1000 && "red", fontWeight: funding.details?.length >= 900 && "bold"}}>{funding.details?.length}/1000*</span>
                                                </Tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            ))}
                        </table>
                    </fieldset>
                    <fieldset>
                        <legend>7. Publication Record at VT</legend>
                        <p>
                            List all publications that are in preparation or have been submitted, accepted, and published.
                            Include the year, status, DOI (if applicable), and a brief description of the publication.
                        </p>
                        <table className="table publicationsTable">
                            <thead>
                                <tr>
                                    <th>Year</th>
                                    <th>Status</th>
                                    <th>DOI</th>
                                    <th></th>
                                </tr>
                            </thead>
                            {publications.length === 0 ? 
                                <tbody>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            : publications.map((pub, index) => (
                                <tbody key={index}>
                                    <tr>
                                        <td>
                                            <select
                                                className="form-select"
                                                id={`publication.${index}.year`}
                                                name={`publication.${index}.year`}
                                                value={pub.year}
                                                onChange={handlePublication}
                                            >
                                                <option></option>
                                                {publicationYears.map((y) => (
                                                    <option key={y} value={y}>{y}</option>
                                                ))}
                                            </select>
                                        </td>
                                        <td>
                                            <select
                                                className="form-select"
                                                id={`publication.${index}.status`}
                                                name={`publication.${index}.status`}
                                                value={pub.status}
                                                onChange={handlePublication}
                                            >
                                                <option value={0}>In Preparation</option>
                                                <option value={1}>Submitted</option>
                                                <option value={2}>Accepted</option>
                                                <option value={3}>Published</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id={`publication.${index}.doi`}
                                                name={`publication.${index}.doi`}
                                                value={pub.doi}
                                                onChange={handlePublication}
                                            />
                                        </td>
                                        <td>
                                            <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() => dropPublication(index)}
                                            >Delete</button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label
                                                htmlFor={`publication.${index}.description`}
                                                className="form-label"
                                            >Description:</label>
                                        </td>
                                        <td colSpan={3}>
                                            <ReactQuill
                                                theme="snow"
                                                value={pub.description}
                                                onChange={(value) => handlePublication({target:{
                                                    name: `publication.${index}.description`,
                                                    type: "text",
                                                    value,
                                                    checked: false,
                                                }})}
                                                modules={{toolbar: [
                                                    ['bold', 'italic', 'underline'], 
                                                    [{ list: 'ordered' }, { list: 'bullet' }], 
                                                    ['link'], 
                                                ],}}
                                            />
                                            <div style={{textAlign:"right"}}>
                                                <Tooltip title="Styling takes up extra characters">
                                                    <span style={{color: pub.description?.length > 2000 && "red", fontWeight: pub.description?.length >= 1900 && "bold"}}>{pub.description?.length}/2000*</span>
                                                </Tooltip>
                                            </div>
                                            {!!errors.publication?.[index]?.description &&
                                                <span className="feedback">{errors.publication[index].description}</span>
                                            }
                                        </td>
                                    </tr>
                                    {!!errors.publication?.[index]?.year && <tr>
                                        <td colSpan={4}><span className="feedback">{errors.publication[index].year}</span></td>
                                    </tr>}
                                </tbody>
                            ))}
                        </table>
                        <button
                            type="button"
                            className="btn btn-success add-button"
                            onClick={addPublication}
                        >Add Publication</button>
                    </fieldset>
                    <fieldset>
                        <legend>8. Presentations</legend>
                        <p>
                            List conference Presentations from the past year to include papers, presentations, and posters at institutional and professional conferences.
                            This includes VT research symposia sponsored by departments, schools, and Colleges.
                            Provide complete citation information, and <strong style={{color:"inherit"}}>bold or underline</strong> the presenter.
                        </p>
                        <ReactQuill
                            theme="snow"
                            value={sar.presentations}
                            onChange={(value) => handleChange({target:{
                                name: "presentations",
                                type: "text",
                                value,
                                checked: false,
                            }})}
                            modules={{toolbar: [
                                ['bold', 'italic', 'underline'], 
                                [{ list: 'ordered' }, { list: 'bullet' }], 
                                ['link'], 
                            ],}}
                        />
                        <div style={{textAlign:"right"}}>
                            <Tooltip title="Styling takes up extra characters">
                                <span style={{color: sar.presentations?.length > 2000 && "red", fontWeight: sar.presentations?.length >= 1900 && "bold"}}>{sar.presentations?.length}/2000*</span>
                            </Tooltip>
                        </div>
                        {!!errors.presentations &&
                            <span className="feedback">{errors.presentations}</span>
                        }
                    </fieldset>
                    <fieldset>
                        <legend>9. Internships</legend>
                        <p>
                            Please provide details on any internships completed during your graduate program or planned for the upcoming year.
                            Provide the organization, role, location (if relevant), and the time period (e.g., Summer 2025).
                            If applicable, briefly describe how the internship relates to your research, career goals, or professional development.
                        </p>
                        <ReactQuill
                            theme="snow"
                            value={sar.internships}
                            onChange={(value) => handleChange({target:{
                                name: `internships`,
                                type: "text",
                                value,
                                checked: false,
                            }})}
                            modules={{toolbar: [
                                ['bold', 'italic', 'underline'], 
                                [{ list: 'ordered' }, { list: 'bullet' }], 
                                ['link'], 
                            ],}}
                        />
                        <div style={{textAlign:"right"}}>
                            <Tooltip title="Styling takes up extra characters">
                                <span style={{color: sar.internships?.length > 2000 && "red", fontWeight: sar.internships?.length >= 1900 && "bold"}}>{sar.internships?.length}/2000*</span>
                            </Tooltip>
                        </div>
                        {!!errors.internships &&
                            <span className="feedback">{errors.internships}</span>
                        }
                    </fieldset>
                    <fieldset>
                        <legend>10. Departmental Activities</legend>
                        <p>
                            List ways you have participated in your department, college, or university community.
                            This might include leadership roles, committee service, mentoring, outreach, volunteering, organizing events, student organizations, recruiting activities, or helping with department initiatives.
                        </p>
                        <ReactQuill
                            theme="snow"
                            value={sar.activities}
                            onChange={(value) => handleChange({target:{
                                name: `activities`,
                                type: "text",
                                value,
                                checked: false,
                            }})}
                            modules={{toolbar: [
                                ['bold', 'italic', 'underline'], 
                                [{ list: 'ordered' }, { list: 'bullet' }], 
                                ['link'], 
                            ],}}
                        />
                        <div style={{textAlign:"right"}}>
                            <Tooltip title="Styling takes up extra characters">
                                <span style={{color: sar.activities?.length > 2000 && "red", fontWeight: sar.activities?.length >= 1900 && "bold"}}>{sar.activities?.length}/2000*</span>
                            </Tooltip>
                        </div>
                        {!!errors.activities &&
                            <span className="feedback">{errors.activities}</span>
                        }
                    </fieldset>
                    <fieldset>
                        <legend>11. Accomplishments so far</legend>
                        <p>
                            Describe key accomplishments during the reporting period.
                            This may include coursework completed, research progress, publications or manuscripts, conference presentations, awards, teaching or mentoring activities, proposal development, exams completed (e.g., qualifier/prelim), or other significant academic milestones.
                        </p>
                        <ReactQuill
                            theme="snow"
                            value={sar.accomplishments}
                            onChange={(value) => handleChange({target:{
                                name: 'accomplishments',
                                type: "text",
                                value,
                                checked: false,
                            }})}
                            modules={{toolbar: [
                                ['bold', 'italic', 'underline'], 
                                [{ list: 'ordered' }, { list: 'bullet' }], 
                                ['link'], 
                            ],}}
                        />
                        <div style={{textAlign:"right"}}>
                            <Tooltip title="Styling takes up extra characters">
                                <span style={{color: sar.accomplishments?.length > 2000 && "red", fontWeight: sar.accomplishments?.length >= 1900 && "bold"}}>{sar.accomplishments?.length}/2000*</span>
                            </Tooltip>
                        </div>
                        {!!errors.accomplishments &&
                            <span className="feedback">{errors.accomplishments}</span>
                        }
                    </fieldset>
                    <fieldset>
                        <legend>12. Plans and Goals</legend>
                        <p>
                            Outline your academic and research goals for the coming year.
                            This may include coursework plans, research milestones, publications, conference submissions, exams (qualifier/prelim), dissertation progress, internships, or other professional goals.
                        </p>
                        <ReactQuill
                            theme="snow"
                            value={sar.plansAndGoals}
                            onChange={(value) => handleChange({target:{
                                name: `plansAndGoals`,
                                type: "text",
                                value,
                                checked: false,
                            }})}
                            modules={{toolbar: [
                                ['bold', 'italic', 'underline'], 
                                [{ list: 'ordered' }, { list: 'bullet' }], 
                                ['link'], 
                            ],}}
                        />
                        <div style={{textAlign:"right"}}>
                            <Tooltip title="Styling takes up extra characters">
                                <span style={{color: sar.plansAndGoals?.length > 2000 && "red", fontWeight: sar.plansAndGoals?.length >= 1900 && "bold"}}>{sar.plansAndGoals?.length}/2000*</span>
                            </Tooltip>
                        </div>
                        {!!errors.plansAndGoals &&
                            <span className="feedback">{errors.plansAndGoals}</span>
                        }
                    </fieldset>
                    <fieldset>
                        <legend>13. Individual Development Plan</legend>
                        <div>
                            <label
                                className="form-label"
                                htmlFor="idp_education"
                            >
                                <strong style={{color:"inherit"}}>Educational Goals</strong> -
                                Describe your learning goals related to coursework, research skills, or knowledge areas you plan to develop as part of your graduate training.
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={sar.idp_education}
                                onChange={(value) => handleChange({target:{
                                    name: `idp_education`,
                                    type: "text",
                                    value,
                                    checked: false,
                                }})}
                                modules={{toolbar: [
                                    ['bold', 'italic', 'underline'], 
                                    [{ list: 'ordered' }, { list: 'bullet' }], 
                                    ['link'], 
                                ],}}
                            />
                            <div style={{textAlign:"right"}}>
                                <Tooltip title="Styling takes up extra characters">
                                    <span style={{color: sar.idp_education?.length > 2000 && "red", fontWeight: sar.idp_education?.length >= 1900 && "bold"}}>{sar.idp_education?.length}/2000*</span>
                                </Tooltip>
                            </div>
                        </div>
                        {!!errors.idp_education &&
                            <div className="form-options-div">
                                <span className="feedback">{errors.idp_education}</span>
                            </div>
                        }
                        <div>
                            <label
                                className="form-label"
                                htmlFor="idp_career"
                            >
                                <strong style={{color:"inherit"}}>Career Exploration</strong> -
                                Describe steps you are taking to explore potential career paths (academic, industry, government, non-profit, etc.). This may include informational interviews, networking, internships, career events, or other exploratory activities.
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={sar.idp_career}
                                onChange={(value) => handleChange({target:{
                                    name: `idp_career`,
                                    type: "text",
                                    value,
                                    checked: false,
                                }})}
                                modules={{toolbar: [
                                    ['bold', 'italic', 'underline'], 
                                    [{ list: 'ordered' }, { list: 'bullet' }], 
                                    ['link'], 
                                ],}}
                            />
                            <div style={{textAlign:"right"}}>
                                <Tooltip title="Styling takes up extra characters">
                                    <span style={{color: sar.idp_career?.length > 2000 && "red", fontWeight: sar.idp_career?.length >= 1900 && "bold"}}>{sar.idp_career?.length}/2000*</span>
                                </Tooltip>
                            </div>
                        </div>
                        {!!errors.idp_career &&
                            <div className="form-options-div">
                                <span className="feedback">{errors.idp_career}</span>
                            </div>
                        }
                        <div>
                            <label
                                className="form-label"
                                htmlFor="idp_professional"
                            >
                                <strong style={{color:"inherit"}}>Professional Development</strong> -
                                List activities that support your professional growth. Examples include workshops, certifications, conferences, teaching development, leadership training, professional society involvement, or skill-building opportunities.
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={sar.idp_professional}
                                onChange={(value) => handleChange({target:{
                                    name: `idp_professional`,
                                    type: "text",
                                    value,
                                    checked: false,
                                }})}
                                modules={{toolbar: [
                                    ['bold', 'italic', 'underline'], 
                                    [{ list: 'ordered' }, { list: 'bullet' }], 
                                    ['link'], 
                                ],}}
                            />
                            <div style={{textAlign:"right"}}>
                                <Tooltip title="Styling takes up extra characters">
                                    <span style={{color: sar.idp_professional?.length > 2000 && "red", fontWeight: sar.idp_professional?.length >= 1900 && "bold"}}>{sar.idp_professional?.length}/2000*</span>
                                </Tooltip>
                            </div>
                        </div>
                        {!!errors.idp_professional &&
                            <div className="form-options-div">
                                <span className="feedback">{errors.idp_professional}</span>
                            </div>
                        }
                    </fieldset>


                    <hr style={{borderWidth:"2px", color:"red", borderStyle:"dashed"}}/>
                    <h2 style={{color: "red"}}>
                        For the following sections, all responses are provided only to the Graduate Program Office and used to improve advising.
                    </h2>
                    <hr style={{borderWidth:"2px", color:"red", borderStyle:"dashed"}}/>

                    <h1>Department Evaluation</h1>
                    {Object.keys(deptEval).length > 0 && <fieldset>
                        <ol>
                            <li>
                                <p>Do you feel included and supported as a member of the department community?</p>
                                <div className="ea-options-div" style={{display:"flex", flexWrap:"wrap"}}>
                                    <div className="ea-radios">
                                        <input
                                            type="radio"
                                            id={`deptEval.inclusive_value-Very_Satisfied`}
                                            name={`deptEval.inclusive_value`}
                                            value={4}
                                            checked={deptEval.inclusive_value === 4}
                                            onChange={(e) => {
                                                handleDeptEval(e);
                                            }}
                                        />
                                        <label className="form-radio-options" htmlFor={`deptEval.inclusive_value-Very_Satisfied`}>Very Satisfied</label>
                                    </div>
                                    <div className="ea-radios">
                                        <input
                                            type="radio"
                                            id={`deptEval.inclusive_value-Satisfied`}
                                            name={`deptEval.inclusive_value`}
                                            value={3}
                                            checked={deptEval.inclusive_value === 3}
                                            onChange={handleDeptEval}
                                        />
                                        <label className="form-radio-options" htmlFor={`deptEval.inclusive_value-Satisfied`}>Satisfied</label>
                                    </div>
                                    <div className="ea-radios">
                                        <input
                                            type="radio"
                                            id={`deptEval.inclusive_value-Neutral`}
                                            name={`deptEval.inclusive_value`}
                                            value={2}
                                            checked={deptEval.inclusive_value === 2}
                                            onChange={handleDeptEval}
                                        />
                                        <label className="form-radio-options" htmlFor={`deptEval.inclusive_value-Neutral`}>Neutral</label>
                                    </div>
                                    <div className="ea-radios">
                                        <input
                                            type="radio"
                                            id={`deptEval.inclusive_value-Dissatisfied`}
                                            name={`deptEval.inclusive_value`}
                                            value={1}
                                            checked={deptEval.inclusive_value === 1}
                                            onChange={handleDeptEval}
                                        />
                                        <label className="form-radio-options" htmlFor={`deptEval.inclusive_value-Dissatisfied`}>Dissatisfied</label>
                                    </div>
                                    <div className="ea-radios">
                                        <input
                                            type="radio"
                                            id={`deptEval.inclusive_value-Very_Dissatisfied`}
                                            name={`deptEval.inclusive_value`}
                                            value={0}
                                            checked={deptEval.inclusive_value === 0}
                                            onChange={handleDeptEval}
                                        />
                                        <label className="form-radio-options" htmlFor={`deptEval.inclusive_value-Very_Dissatisfied`}>Very Dissatisfied</label>
                                    </div>
                                    
                                </div>
                                <span className="feedback">{errors.deptEval_inclusive_value}</span>
                                <ReactQuill
                                    theme="snow"
                                    defaultValue={`${deptEval.inclusive_text}`}
                                    onChange={(value) => handleDeptEval({target:{
                                        name: `deptEval.inclusive_text`,
                                        type: "text",
                                        value,
                                        checked: false,
                                    }})}
                                    modules={{toolbar: [
                                        ['bold', 'italic', 'underline'], 
                                        [{ list: 'ordered' }, { list: 'bullet' }], 
                                        ['link'], 
                                    ],}}
                                    placeholder="Optional place to provide further explanation."
                                />
                                <div style={{textAlign:"right"}}>
                                    <Tooltip title="Styling takes up extra characters">
                                        <span style={{color: deptEval.inclusive_text?.length > 2000 && "red", fontWeight: deptEval.inclusive_text?.length >= 1900 && "bold"}}>{deptEval.inclusive_text?.length}/2000*</span>
                                    </Tooltip>
                                </div>
                                {!!errors.deptEval_inclusive_text &&
                                    <span className="feedback">{errors.deptEval_inclusive_text}</span>
                                }
                            </li>
                            <li>
                                <p>Are there any additional departmental activities you would like to see offered?</p>
                                <ReactQuill
                                    theme="snow"
                                    defaultValue={`${deptEval.additions}`}
                                    onChange={(value) => handleDeptEval({target:{
                                        name: `deptEval.additions`,
                                        type: "text",
                                        value,
                                        checked: false,
                                    }})}
                                    modules={{toolbar: [
                                        ['bold', 'italic', 'underline'], 
                                        [{ list: 'ordered' }, { list: 'bullet' }], 
                                        ['link'], 
                                    ],}}
                                    placeholder="Optional place to provide an answer."
                                />
                                <div style={{textAlign:"right"}}>
                                    <Tooltip title="Styling takes up extra characters">
                                        <span style={{color: deptEval.additions?.length > 2000 && "red", fontWeight: deptEval.additions?.length >= 1900 && "bold"}}>{deptEval.additions?.length}/2000*</span>
                                    </Tooltip>
                                </div>
                                {!!errors.deptEval_additions &&
                                    <span className="feedback">{errors.deptEval_additions}</span>
                                }
                            </li>
                        </ol>
                    </fieldset>}

                    <h1>Evaluation of your Advisors</h1>





                    <fieldset style={{minWidth: "800px"}}>
                        <legend>Who are your advisors?</legend>
                        <p>
                            Please pick your faculty advisor(s) and then the time period in which they advised you.
                            Include all faculty advisors you have had and if they are not listed here please contact <a href="mailto:gradinfo@cs.vt.edu" target="_blank">gradinfo@cs.vt.edu</a> to add them.
                            Below you are required to evaluate all of your current Faculty Advisors, and can choose to evaluate past advisors.
                        </p>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Faculty Member</th>
                                    <th>Dates</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {facultyAdvisors.length === 0 ?
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                : facultyAdvisors.map((facAdvisor, i) => (
                                    <tr key={`facAdvisor${i}`}>
                                        <td>
                                            <select
                                                id={`facAdvisors.${i}.advisorPID`}
                                                name={`facAdvisors.${i}.advisorPID`}
                                                className="form-select"
                                                value={facAdvisor.advisorPID}
                                                onChange={handleFacultyAdvisors}
                                            >
                                                <option value=""></option>
                                                {allFaculty.map((faculty) => (
                                                    <option key={faculty.pid} value={faculty.pid}>{faculty.last}, {faculty.first} ({faculty.pid})</option>
                                                ))}
                                            </select>
                                        </td>
                                        <td>
                                            <div className="ea-wrapper">
                                                <span>From:</span>
                                                <TermSelector2
                                                    id={`facAdvisors.${i}.start`}
                                                    name={`facAdvisors.${i}.start`}
                                                    title={`facAdvisors.${i}.start`}
                                                    term={facAdvisor.start}
                                                    termSetter={function (term) {
                                                        handleFacultyAdvisors({target:{
                                                            name: `facAdvisors.${i}.start`,
                                                            type: 'text',
                                                            value: term,
                                                            checked: false
                                                        }});
                                                    }}
                                                    yearMin={currentYear-10}
                                                    yearMax={currentYear}
                                                />
                                                <span>To:</span>
                                                <TermSelector2
                                                    id={`facAdvisors.${i}.end`}
                                                    name={`facAdvisors.${i}.end`}
                                                    title={`facAdvisors.${i}.end`}
                                                    term={facAdvisor.end}
                                                    termSetter={function (term) {
                                                        handleFacultyAdvisors({target:{
                                                            name: `facAdvisors.${i}.end`,
                                                            type: 'text',
                                                            value: term,
                                                            checked: false
                                                        }});
                                                    }}
                                                    yearMin={currentYear-10}
                                                    yearMax={currentYear}
                                                    disabled={facAdvisor.end === -1}
                                                />
                                                {
                                                    facAdvisor.start > facAdvisor.end &&
                                                    Math.floor(facAdvisor.start/100) !== 0 &&
                                                    facAdvisor.start%100 !== 0 &&
                                                    Math.floor(facAdvisor.end/100) !== 0 &&
                                                    facAdvisor.end%100 !== 0 &&
                                                    facAdvisor.end !== -1 &&
                                                    <>
                                                        <div>{/* Empty for spacing */}</div>
                                                        <span style={{color:"red"}}>Your 'To' semester must be the same or come after your 'From' semester.</span>
                                                    </>
                                                }
                                                <div>{/* Empty for spacing */}</div>
                                                <div className="form-check">
                                                    <input
                                                        id={`facAdvisors.${i}.current`}
                                                        name={`facAdvisors.${i}.current`}
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        onChange={(event) => {
                                                            handleFacultyAdvisors({target:{
                                                                name: `facAdvisors.${i}.end`,
                                                                type: 'text',
                                                                value: event.target.checked ? -1 : 0,
                                                                checked: false
                                                            }});
                                                        }}
                                                        checked={facAdvisor.end === -1}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor={`facAdvisors.${i}.current`}
                                                        style={{textAlign:"left"}}
                                                    >They are currently my advisor.</label>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() => dropFacAdvisor(i)}
                                            >Delete</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <button
                            type="button"
                            className="btn btn-success add-button"
                            onClick={() => addFacAdvisor()}
                        >Add Faculty Advisor</button>
                        {!hasCurrentFA && <>
                            <p htmlFor="whyNoCFA">Why don't you <b>currently</b> have a faculty advisor?</p>
                            <ReactQuill
                                theme="snow"
                                value={sar.whyNoCFA}
                                onChange={(value) => handleChange({target:{
                                    name: `whyNoCFA`,
                                    type: "text",
                                    value,
                                    checked: false,
                                }})}
                                modules={{toolbar: [
                                    ['bold', 'italic', 'underline'], 
                                    [{ list: 'ordered' }, { list: 'bullet' }], 
                                    ['link'], 
                                ],}}
                            />
                            <div style={{textAlign:"right"}}>
                                <Tooltip title="Styling takes up extra characters">
                                    <span style={{color: sar.whyNoCFA?.length > 2000 && "red", fontWeight: sar.whyNoCFA?.length >= 1900 && "bold"}}>{sar.whyNoCFA?.length}/2000*</span>
                                </Tooltip>
                            </div>
                            <span className="feedback">{errors.whyNoCFA}</span>
                        </>}
                    </fieldset>
                    {facultyAdvisors.map((fa, i) => (
                        !!evalOfAdvisors[i] ?
                            <EvaluationOfAdvisor
                                key={i}
                                index={i}
                                advisor={fa}
                                evaluation={evalOfAdvisors[i]}
                                setEvaluation={handleEoA}
                                dropEvaluation={dropEoA}
                                validating={validating}
                                handleEoAErrors={handleEoAErrors}
                            />
                        : <></>
                    ))}
                    <div className="add-button">
                        <select
                            className="form-select"
                            id="eoa-add-select"
                            name="eoa-add-select"
                            value={newEoA}
                            onChange={(e) => setNewEoA(parseInt(e.target.value))}
                        >
                            <option value={-1}></option>
                            {facultyAdvisors.map((fa,i) => (!!fa.advisorPID &&
                                    fa.start > 0 &&
                                    fa.end > 0 &&
                                    !evalOfAdvisors[i] &&
                                <option key={i} value={i}>{fa.last}, {fa.first} ({displayTerm(fa.start)} - {fa.end === -1 ? "Now": displayTerm(fa.end)})</option>
                            ))}
                        </select>
                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => addEoA(newEoA)}
                            disabled={newEoA === -1}
                        >Add Evaluation</button>
                    </div>
                </form>
            </>
            :
                <h1>Loading SAR...</h1>
            }
            <div
                className="footer"
                style={{
                    position:"fixed",
                    left: 0,
                    bottom: 0,
                    width: "100%",
                    backgroundColor: "#68293b",
                }}
            >
                <div
                    className="add-button"
                    style={{
                        padding:"10px 20px",
                        display:"flex",
                        alignItems:"baseline",
                    }}
                >
                    <div className="form-check">
                        <input
                            id="validation-checkbox"
                            name="validation-checkbox"
                            type="checkbox"
                            className="form-check-input"
                            checked={validating}
                            onChange={(e) => setValidating(e.target.checked)}
                        />
                        <label
                            htmlFor="validation-checkbox"
                            className="form-check-label"
                            style={{color:"white", paddingRight:"10px"}}
                        >Validating?</label>
                    </div>
                    {CurrentUser.pid === "bbradner" &&
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={showInfo}
                        >Info</button>
                    }
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => onSubmit(false)}
                    >Save</button>
                    <button
                        type="button"
                        className="btn btn-warning"
                        onClick={() => onSubmit(true)}
                    >Submit</button>
                </div>
            </div>
        </div>
    )
}